/*
 * @Date: 2021-07-14 22:53:42
 * @LastEditors: 于鸿儒
 * @LastEditTime: 2021-07-17 05:13:12
 * @FilePath: /fdmba2021/src/router/index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
    // mode: 'history',
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    },
    base: '/',
    routes: []
})